module.exports = __webpack_public_path__ + "static/media/facebook_login_btn_img.c98e1dd8.png";